import React from 'react';
import InterveneOrganisationSearchableSelect from '../../intervene/components/InterveneOrganisationSearchableSelect';

export default function BusinessFunctionOrgFilter({
  value,
  onChange,
  sx,
  label = 'Organisation',
  placeholder = 'All organisations',
  required = false,
}) {
  return (
    <InterveneOrganisationSearchableSelect
      label={label}
      placeholder={placeholder}
      required={required}
      selectedOrganisation={value || null}
      valueId={value?.organisation_id ?? value?.id ?? null}
      onChange={onChange}
      sx={sx}
    />
  );
}
